$('#close-blog-filter, #blog-filter-submit-results').on('click', function () {
  closeFilterModal();
})

$('#reset-blog-filter').on('click', function () {
  $('.article-filters .filter-check:checked').each( function () {
    $(this).prop('checked', false)
  })
  $('#blog-filter-submit-results').addClass('active')
  getFilterCreateArticles()
})

$('#cat-filters-wrapper').on('click', function(e) {
  if (e.target !== this) {
    return;
  }
  closeFilterModal();
});

const closeFilterModal = () => {
  $('body').removeClass('filter-open')
  $('#blog-filter-submit-results').removeClass('active')
}

$('#blog-filter-toggle').on('click', function () {
  $('body').addClass('filter-open')
})

$('.article-filters .filter-check').change(function() {
  $('#blog-filter-submit-results').addClass('active')
  $('#blog-search-input').val('')
  var tag = $(this).attr('id');
  getFilterCreateArticles();
});

const removeFilterTag = (tag) => {
  const tagSlug = $(tag).data('remove-tag')
  $(`.tag-${tagSlug}`).prop('checked', false)
  getFilterCreateArticles()
}

var $searchInput = $('#blog-search-input');
var typingTimer; //timer identifier
var doneTypingInterval = 750;

const getBlogSearchResults = (searchTerm, page) => {
  if ( !searchTerm ) {
    getFilterCreateArticles()
    return
  }
  let searchURL = `/search?type=article&q=${encodeURIComponent(searchTerm)}&view=blog-filter`
  if ( page ) {
    searchURL += `&page=${page}`
  }
  $('.catalog-product-grid').html('<div class="h1 blog-loading loading text-center font-bemio uppercase py-5">Loading</div>')
  $.ajax({
    type: 'GET',
    url: searchURL,
    dataType: 'json',
    success: function(res){
      $('.catalog-product-grid').html('')
      $('.filter-check').each( function () {
        $(this).prop('checked', false)
      })
      
      $('.selected-tags').html('')
      let baseUrl = window.location.href.split('/tagged')[0]
      baseUrl = baseUrl.split('?')[0]
      baseUrl = baseUrl.slice(-1) === '/' ? baseUrl.slice(0, -1) : baseUrl

      let searchUrl = `${baseUrl}/?q=${searchTerm}`
      if ( res.page !== '1' ) {
        searchUrl += `&page=${res.page}`
      }

      // Replace url with search params
      window.history.replaceState(null, $('.blog-title a').text() + 'tagged with ' + searchTerm, searchUrl);

      // Add search pagination
      const pagination = decodeURIComponent(res.pagination);
      $('#blog-pagination').html(pagination)

      // Switch search pagination urls 
      $('.paginate-link').each( function () {
        let newSearchUrl = $(this).attr('href').replace('/search', baseUrl)
        newSearchUrl = removeURLParameter(newSearchUrl, 'view')
        newSearchUrl = removeURLParameter(newSearchUrl, 'type')
        $(this).attr('href', newSearchUrl)
      })
      
      // Clear catalog grid before appending new items
      
      $.each(res.articles, function(index, item) {
        // console.log("filter found: " + res['articles'][index]['title']);
        var date = item.date;
        var url = item.url;
        var bg = item.image;
        var title = item.title;
        if (item.excerpt != "") {
          var excerpt = item.excerpt;
        } else {
          var excerpt = item.content;
        }
        createArticle(date, url, bg, title, excerpt);
      });
    },
    error: function(req, status){
      console.log(req, status);
    }
  })
}

const submitSearch = () => {
  const searchTerm = $('#blog-search-input').val()
  getBlogSearchResults(searchTerm)
}

$searchInput.on('keyup', function () {
  clearTimeout(typingTimer);
  typingTimer = setTimeout(submitSearch, doneTypingInterval);
})

$searchInput.on('keydown', function () {
  clearTimeout(typingTimer);
});

if ( $('#blog-search-form').length ) {
  $('#blog-search-form').on('submit', function (e) {
    e.preventDefault()
    submitSearch()
  })
  
  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get('q');
  const page = urlParams.get('page');
  
  if ( searchQuery ) {
    $('#blog-search-input').val(searchQuery)
    getBlogSearchResults(searchQuery, page)
  }
}

//Ajax get articles
const getFilterCreateArticles = () => {
  var checkList = [];
  // Clear all remove tags and add them back based on checked options
  $('.selected-tags').html('')
  $('#cat-filters input[type=checkbox]:checked').each(function() {
    const tag = $(this).attr('id')
    checkList.push(tag);
    const removeTag = $('.blog-filter-tag-dummy').clone()
    $(removeTag[0]).data('remove-tag', tag).css('display', 'flex').removeClass('blog-filter-tag-dummy')
    $('span', removeTag[0]).text($(this).data('name'))
    $('.selected-tags').append(removeTag)
  });
  
  var len = checkList.length;
  if ( len ) {
    $('#reset-blog-filter').removeClass('hidden')
  } else {
    $('#reset-blog-filter').addClass('hidden')
  }
  // console.log(tag + ' filter activated');
  const filterList = checkList.join('+')
  var currUrl =  removeURLParameter(window.location.href, 'page').split('/tagged/')[0];
  currUrl = currUrl.split('?')[0]
  currUrl = currUrl.slice(-1) === '/' ? currUrl.slice(0, -1) : currUrl
  currUrl += len 
    ? '/tagged/' + filterList
    : ''
  window.history.replaceState(null, $('.blog-title a').text() + 'tagged with ' + filterList, currUrl);
  $('.catalog-product-grid').attr('data-filters', filterList);
  $('.catalog-product-grid .unfiltered').addClass('hidden');
  $('.catalog-product-grid .filtered').remove();
  
  // } else if (len == 0) {
    // console.log('filters cleared');
    // $('.catalog-product-grid').attr('data-filters', "none");
    // $('.catalog-product-grid .filtered').remove();
    // $('.catalog-product-grid .unfiltered, label, .catalog-filters-wrap ul li.hidden').removeClass('hidden');
    // hideShowBlogFilterOptions();
  // }
  var currUrl =  removeURLParameter(window.location.href, 'page');
  ajaxTarget = currUrl+'?view=ajax';
  $('.catalog-product-grid').html('<div class="h3 blog-loading loading text-center font-bemio uppercase py-5">Loading</div>')
  $.ajax({
    type: 'GET',
    url: ajaxTarget,
    dataType: 'json',
    success: function(res){
      $('.catalog-product-grid').html('')
      // Decode pagination and append to pagination div
      const pagination = decodeURIComponent(res.pagination);
      $('#blog-pagination').html(pagination)
      $.each(res['articles'], function(index, item) {
        // console.log("filter found: " + res['articles'][index]['title']);
        var date = res['articles'][index]['date'];
        var url = res['articles'][index]['url'];
        var bg = res['articles'][index]['image'];
        var title = res['articles'][index]['title'];
        if (res['articles'][index]['excerpt'] != "") {
          var excerpt = res['articles'][index]['excerpt'];
        } else {
          var excerpt = res['articles'][index]['content'];
        }
        createArticle(date, url, bg, title, excerpt);
      });
      $('label').each(function() {
        var tag = $(this).attr('data-url');
        if($.inArray(tag, res['tags']) == -1) {
          $(this).addClass("hidden");
          $(this).parent().addClass("hidden");
        } else {
          $(this).removeClass("hidden");
          $(this).parent().removeClass("hidden");
        };
      });
      // hideShowBlogFilterOptions();
    },
    error: function(req, status){
          console.log(req, status);
    }
  })
}
  
const createArticle = (date, url, bg, title, excerpt, tag) => {
    var divCont  = `<div class="catalog-product filtered ${tag}">`;
    var divOv = `<div class="catalog-product-overlay" style="background: linear-gradient( rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35) ), url(${bg}) no-repeat center center / cover">`;
    var divInfo = `<div class="article-info">
                    <p class="catalog-title">
                      <a class="title" href="${url}">${title}</a>
                    </p><p class="article-date">${date}</p>
                  </div>`;
    var divExcerpt = `<div class="article-excerpt">
                        <p>${excerpt}</p>
                        <a class="read-more" href="${url}">Continue Reading</a>
                      </div>`;
    var divOvClose = '</div>';
    var divMobileOpen = '<div class="mobile-article mobile">';
    var divMobileClose = '</div>';
    var divClose1 = '</div>';
    var divClose2 = '</div>';
  
    var div = divCont +
              divOv +
              divInfo +
              divExcerpt +
              divOvClose +
              divMobileOpen +
              divInfo +
              divExcerpt +
              divMobileClose +
              divClose1 +
              divClose2;
    $('.catalog-product-grid').append(div);
}

//Hide Empty Filter Blocks
const hideShowBlogFilterOptions = () => {
  $('.catalog-filters .filter-block').each(function () {
    if ($(this).children('ul').children('li:not(.hidden)').length < 1) {
      $(this).hide();
    } else if ($(this).css('display') == 'none' ) {
      $(this).show();
    }
  });
  $('.filter-block').each( function () {
    // If all li elements of the current category are hidden, hide the whole category
    if ( $('li.hidden', this).length === $('li', this).length ) {
      $(this).hide()
    } else {
      $(this).show()
    }
  })
}